// export const DOT_REGEXP = /^(USDOT\s)?\d{5, 20}$/
export const DOT_REGEXP = /^[\d-]{2,9}$/;
